import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  AI_AGENTS_ENDPOINTS,
  AI_AGENTS_QUERY_KEYS,
} from 'app/modules/aiAgents/queries/queryData';
import { post } from 'app/shared/utils/fetchr';
import { PaginatedAiAgentsResponse } from 'app/modules/aiAgents/responses';
import { useSelector } from 'react-redux';
import { selectHasReadAiAgentsPermission } from 'app/modules/session/selectors';
import { GetAiAgentsPayload } from 'app/modules/aiAgents/requests';

export const useGetAiAgents = (payload: GetAiAgentsPayload) => {
  const hasReadAiAgentsPermission = useSelector(
    selectHasReadAiAgentsPermission,
  );
  return useQuery({
    queryKey: AI_AGENTS_QUERY_KEYS.list(payload),
    queryFn: (): Promise<PaginatedAiAgentsResponse> =>
      post(AI_AGENTS_ENDPOINTS.list(), payload),
    // the placeholder data is os that it doesn't go into a loading state when
    // you press to go to the next page
    // See https://tanstack.com/query/latest/docs/framework/react/guides/paginated-queries
    placeholderData: keepPreviousData,
    enabled: hasReadAiAgentsPermission,
  });
};
